const restrictedRoutesInProd = ["/markets", "/deal", "/margin-trade" , "/spot-trade"];
export default restrictedRoutesInProd;
